/**
 * @Relay no-runtime
 */
/**
 * @graphql cc
 */
import type ApolloClient from 'apollo-client';
import graphql from 'graphql-tag';

import type { getConsumptionEventDataQuery } from './__types__/getConsumptionEventDataQuery';

export const loadSpaceAndContentData = async (
	client: ApolloClient<object>,
	spaceKey: string,
	contentId: string | undefined,
) => {
	if (!contentId) {
		return Promise.reject(new Error('Content ID is required'));
	}

	const response = await client.query<getConsumptionEventDataQuery>({
		query: graphql`
			query getConsumptionEventDataQuery($spaceKey: String!, $contentId: ID!) {
				space(key: $spaceKey) {
					id
					type
					status
				}
				singleContent(id: $contentId) {
					id
					status
					type
					subType
				}
			}
		`,
		variables: { spaceKey, contentId },
	});

	// this is a workaround to handle the case where the content is restricted
	if (!response.errors && response.data.singleContent === null) {
		return Promise.reject('singleContent is null');
	}

	return response;
};
